import Checkbox from "../../../components/Checkbox";
import React, { useCallback, useEffect, useState } from "react"
import { PATH_PROPERTY } from "../../../Util/constants"
import { useHistory } from "react-router-dom"
import swal from "sweetalert"
import canOff from "../../../assets/property/can-off.svg";
import canOn from "../../../assets/property/can-on.svg";
import starOff from "../../../assets/property/star-off.svg";
import regenerateOn from "../../../assets/property/star-on.svg";
import regenerateOff from "../../../assets/property/star-off.svg";
import starOn from "../../../assets/property/star-on.svg";
import picLeft from "../../../assets/property/pic-left-dark.png";
import picLeftOn from "../../../assets/property/pic-left-on-dark.png";
import picRight from "../../../assets/property/pic-right-dark.png";
import picRightOn from "../../../assets/property/pic-right-on-dark.png";
import switchOff from "../../../assets/property/switch.svg";
import switchOn from "../../../assets/property/switch-on.svg";
import Button from "../../../components/Buttons/Button/Button"
import ImageWithHover from "../../../components/ImageWithHover";
import VTChannelIcon from "../../../assets/channels/icons/VTChannel.svg"
import VTChannelIconOn from "../../../assets/channels/icons/VTChannel-on.svg"
import VTChannelIconOnBlue from "../../../assets/channels/icons/VTChannel-on-blue.svg"
import VTChannelLabel from "../../../assets/channels/icons/label-VTChannel.svg"

import SHChannelIcon from "../../../assets/channels/icons/SHChannel.svg"
import SHChannelIconOn from "../../../assets/channels/icons/SHChannel-on.svg"
import SHChannelIconOnBlue from "../../../assets/channels/icons/SHChannel-on-blue.svg"
import SHChannelLabel from "../../../assets/channels/icons/label-SHChannel.svg"

import TLChannelIcon from "../../../assets/channels/icons/TLChannel.svg"
import TLChannelIconOn from "../../../assets/channels/icons/TLChannel-on.svg"
import TLChannelIconOnBlue from "../../../assets/channels/icons/TLChannel-on-blue.svg"
import TLChannelLabel from "../../../assets/channels/icons/label-TLChannel.svg"

import eventsIcon from "../../../assets/special-collection/icons/events.svg"
import eventsIconOn from "../../../assets/special-collection/icons/events-on.svg"
import eventsIconOnBlue from "../../../assets/special-collection/icons/events-on-blue.svg"
import eventsLabel from "../../../assets/special-collection/icons/label-events.svg"

import dogsIcon from "../../../assets/special-collection/icons/dogs.svg"
import dogsIconOn from "../../../assets/special-collection/icons/dogs-on.svg"
import dogsIconOnBlue from "../../../assets/special-collection/icons/dogs-on-blue.svg"
import dogsLabel from "../../../assets/special-collection/icons/label-pets.svg"

import greenIcon from "../../../assets/special-collection/icons/green.svg"
import greenIconOn from "../../../assets/special-collection/icons/green-on.svg"
import greenIconOnBlue from "../../../assets/special-collection/icons/green-on-blue.svg"
import greenLabel from "../../../assets/special-collection/icons/label-sustainable.svg"

import familiesIcon from "../../../assets/special-collection/icons/kids.svg"
import familiesIconOn from "../../../assets/special-collection/icons/kids-on.svg"
import familiesIconOnBlue from "../../../assets/special-collection/icons/kids-on-blue.svg"
import familiesLabel from "../../../assets/special-collection/icons/label-families.svg"
import bathIcon from "../../../assets/property/baths.png";
import bedsIcon from "../../../assets/property/beds.png";
import peopleIcon from "../../../assets/property/people.png";

import CollectionIcon from "../../../components/CollectionIcon"
import RegionsDropDown from "../../../components/RegionsDropDown"
import "./ListingRow.scss"
import { getStorageValue } from "../../../Util/general";

import axios from "axios";
import constants from "../../../Util/constants"

const Listingrow = (props) => {
  const { property, fullCalendar, id, agent, agency, partner, xdata, updateXdata } = props
  const oldXdata=xdata
  const [chk, setChk] = useState([])
  const [tags, setTags] = useState(xdata?.tags)
  const [region, setNewRegion] = useState(xdata?.region)
  const [subRegion, setNewSubRegion] = useState(xdata?.subRegion)
  const [picIndex, setPicIndex] = useState(0);
  const history = useHistory()
  const [title, setTitle] = useState(xdata.title||property.title)
  const [change, setChange] = useState(null)
  const summary =
    property?.publicDescription?.summary ||
    property?.publicDescription?.space
  const [desc, setDesc] = useState(xdata.desc || summary)
  const [blockChannels, setblockChannels] = useState(!xdata.newListings && partner?.accountId !== '64072805d57d670040d5fab6')
  const partnerLogin = getStorageValue('partnerLogin')
const token2 = '__HUB_SESSION__';

const userRequest = axios.create({
    headers: {
        Authorization: `Bearer ${token2}`
    }
});
  
//By Jaison 2025-07-19 - START  
  const agentLoggedIn = JSON.parse( localStorage.getItem('agent') );
  //const allZipcodes = JSON.parse(getStorageValue('allZipcodes') );
  const extranet_vt_logged_in_role = localStorage.getItem('extranet-vt-logged-in-role');

  const [newRegionFromOpenAI, setNewRegionFromOpenAI] =useState('');
  async function regionLookUpOpenAI(country, zipcode) {

    setNewRegionFromOpenAI('')

    const country_belongs_to = country;
    const zipcode_to_search = zipcode;
 
  
    const res = await userRequest.post(constants.SHUB_URL+'/local/get-touristic-destination-open-ai', {country:country_belongs_to, zipcode:zipcode_to_search} );

    const response = res.data
console.log('NEW REGION:::', response)    

      if(response.success===true && response.destination !== '') {
        console.log('NEW REGION:::', response.destination);
        setNewRegionFromOpenAI(response.destination);

          
          swal({
          show: true,
          icon: 'success',
          title: response.message,
          //text: `Text`
          })
                  

      }
      else if(response.success===true && response.destination === '') {
          swal({
          show: true,
          icon: 'success',
          title: 'AI returned empty region',
          //text: `Text`
          })
      }
      
      else if(response.success===false) {
          swal({
          show: true,
          icon: 'error',
          title: response.message,
          //text: `Text`
          })         
      }    

  }


  
  async function saveNewRegionFromOpenAI(country, zipcode, listingId='') {

    if(newRegionFromOpenAI === '' ) {
        alert('Region is empty');
        return false;
    }

    if(country === '' ) {
        alert('Country is empty');
        return false;
    }  
    
    if(zipcode === '' ) {
        alert('zipcode is empty');
        return false;
    }     

   //alert('country: '+country+', zipcode:' + zipcode + ', listingId:'+ listingId +',  newRegionFromOpenAI:'+newRegionFromOpenAI)
   //console.log('country: '+country+', zipcode:' + zipcode + ', listingId:'+ listingId +',  newRegionFromOpenAI:'+newRegionFromOpenAI)

   let unmapped_properties_mapping_region_data = {country:country, zipcode:zipcode, listingId:listingId, region:newRegionFromOpenAI }

   let confirmMessage = ''
   if(listingId !== '') {
    confirmMessage = 'Are you sure to update the region of the unmapped listing "'+listingId+'" with "'+newRegionFromOpenAI+'" (country='+country+', zipcode='+zipcode+') ?'
   }
   else { //Update all unmapped under the country, selected and zipcode
    confirmMessage = 'Are you sure to update the region of ALL unmapped listings with "'+newRegionFromOpenAI+'" (country='+country+', zipcode='+zipcode+') ?'
   }


   if( window.confirm(confirmMessage) ) {
    // unmapped_properties_mapping_region_data to new api on shub-vthub and update
    const ShubResponse = await userRequest.post(constants.SHUB_URL+'/local/listings/update-unmapped-region-single-or-all-properties-under-country-zipcode', unmapped_properties_mapping_region_data);

    console.log('ShubResponse:::', ShubResponse)

    if(ShubResponse.data.success===true) {
          swal({
          show: true,
          icon: 'success',
          title: ShubResponse.data.message,
          //text: `Text`
          })

          //window.location.reload();
    }
    else if(ShubResponse.data.success===false) {
          swal({
          show: true,
          icon: 'error',
          title: ShubResponse.data.message,
          //text: `Text`
          })
    }


   }

  }
//By Jaison 2025-07-19 - STOP   


  // The title / description rewrite runs on the hub (POST /local/ai-rewrite,
  // 2026-10-23): the browser no longer holds an OpenAI key.
  async function aiRewrite(input, wordCount, exclude, kind) {
    const res = await userRequest.post(constants.SHUB_URL + '/local/ai-rewrite', { text: input || '', words: wordCount, exclude, kind })
    return res?.data?.success ? res.data.text : ''
  }

  async function AITitle(input, wordCount, exclude) {
    try {
      const text = await aiRewrite(input, wordCount, exclude, 'title')
      if (!text) return
      setTitle(text)
      xdata.title = text
      updateXdata(id, xdata, oldXdata, title, 'title')
      return text
    }
    catch {

    }

  }

  async function AIDesc(input, wordCount, exclude) {
    try {
      const text = await aiRewrite(input, wordCount, exclude, 'description')
      if (!text) return
      setDesc(text)
      xdata.desc = text
      updateXdata(id, xdata, oldXdata, title, 'description')
      return text
    }
    catch {

    }

  }

  const updateData = (change) => {
    console.log('NEW REGION:', region, subRegion)
    xdata.tags = tags
    xdata.agent = agent?.firstName + ' ' + agent?.lastName||''
    //xdata.region = region
    //xdata.subRegion = subRegion
    xdata.status = xdata.channel ? (xdata.channel.length > 0) ? "Approved" : xdata?.newListing ? "Pending" : "Declined" : "Pending"
    xdata.agent = agent?.firstName + ' ' + agent?.lastName||''
    localStorage.setItem("xdata", JSON.stringify(xdata))
    // console.log('updating Xdata: id',id,'xdata:',xdata)
    updateXdata(id, xdata, oldXdata, title, change)
  }



  const setAITitle = () => {
    //console.log('xdata:', xdata)
    try {
      AITitle(property?.title, 8, xdata.pmName + ' ' + xdata.nickname)
      AIDesc(summary, 100, xdata.pmName + ' ' + xdata.nickname)
    }
    catch (error) {
      console.error('Caught an error:', error);
    }


    //     console.log('exchanged title:', property._id, property.title, xdata.title)
    // } catch (error) {
    //     console.error('Caught an error:', error);
    // } finally {
    //     console.log('Cleanup actions.');
    // }

    //  console.log('exchanged title:', property._id, property.title, xdata.title)

  }


  const setNextPic = () => {
    setPicIndex((picIndex + 1 >= picLength) ?
      0 : picIndex + 1)
  };

  const setPrevPic = () => {
    setPicIndex(picIndex === 0 ? picLength - 1 : picIndex - 1);
  };

  const removePic = () => {

    // take data.pictures, copy it to xdata.pictures, then slicing the current pic.
    if (!isNullOrEmptyArray(xdata.pictures) && picLength != null && picLength > 1) {
      xdata?.pictures.splice(picIndex, 1)
      //console.log('xdata pics', xdata.pictures)
      updateData(`remove pic #${picIndex}`)
    } else {
      xdata.pictures = property?.pictures
      xdata.pictures.splice(picIndex, 1)
      //console.log('set the xdata.pictures to:', xdata.pictures)
      updateData(`remove pic #${picIndex}`)
    }
    pic = xdata.pictures[picIndex % xdata.pictures?.length].original
    picPosition = picIndex % property.pictures?.length;
    picLength = xdata?.pictures?.length
    //console.log(' removed pic:', picIndex, ' from prop:', property._id, 'xdata pics:', xdata.pictures)
    setPrevPic()
  };
  function swap(arr, from, to) {
    arr.splice(from, 1, arr.splice(to, 1, arr[from])[0]);
  }
  const mainPic = () => {

    // make selected pic the first=main one!
    if (!isNullOrEmptyArray(xdata.pictures) && picLength != null && picLength > 1) {
      swap(xdata?.pictures, 0, picIndex);
      //console.log('xdata pics', xdata.pictures)
      updateData(`replaced main pic from #${picIndex}`)
    } else {
      xdata.pictures = property?.pictures
      swap(xdata?.pictures, 0, picIndex);
      //console.log('set the xdata.pictures to:', xdata.pictures)
      updateData(`replaced main pic from #${picIndex}`)
    }
    setPicIndex(0);
    pic = xdata.pictures[0 % xdata.pictures?.length].original
    picPosition = 0 % xdata.pictures?.length;
    picLength = xdata?.pictures?.length
    //console.log(' main pic from:', picIndex, '  prop:', property._id, 'xdata pics:', xdata.pictures)
  };

  const isNullOrEmptyArray = (arr) => {
    return arr == null || arr.length === 0;
  };

  const toggleCollection = (collection) => {
    const collectionExist = tags.includes(collection)
    if (collectionExist) {
      setTags(tags.filter((f) => f !== collection)) // remove from xdata channel list
    } else {
      setTags([...tags, collection]) // add to xdata channel list
    }
    //console.log('updating Xdata: id',id,'xdata:',xdata)
    updateData(collectionExist?`removed the collection #${collection}`:`added the collection #${collection}`)
  }

  const selectedRegion = (newRegion) => {
    console.log("changing region to:", newRegion)
    setNewRegion(newRegion)
    xdata.region = newRegion
    //updateData()
  }

  const selectedSubRegion = (newSubRegion) => {
    console.log("changing subregion for:", newSubRegion)
    setNewSubRegion(newSubRegion)
    updateData()
  }

  const renderAmount = (title, pic, amount) => {
    return (
      <div className="property-page-body-top-left-info-amount">
        <div className="row d-flex justify-content-center m-2">
          <img src={pic} alt="" style={{ width: "40px" }} />
        </div>
        <div className="row d-flex justify-content-center m-2">{title}</div>
        <div className="row d-flex justify-content-center m-2">
          {amount ? amount : ``}
        </div>
      </div>
    );
  };

  const renderSpecialCollections = () => {
    return (
      /* 	<div>
              <img src={specialEvents} className="img-fluid" style={{ marginRight: '5px', width: '25px' }} />
              <img src={specialFamilies} className="img-fluid" style={{ marginRight: '5px', width: '25px' }} />
              <img src={greenIcon} className="img-fluid" style={{ marginRight: '5px', width: '25px' }} />
              <img src={dogsIcon} className="img-fluid" style={{ marginRight: '5px', width: '25px' }} />
          </div> */
      <div className="search-main-selection-icons"
        style={{
          paddingTop: '5px',
          display: 'grid',
          gridTemplateColumns: '60px 60px 60px 60px',
          justifyItems: 'center',
        }}>
        <CollectionIcon
          readOnly={partnerLogin}
          path={eventsIcon}
          pathOver={eventsIconOn}
          pathOver2={eventsIconOnBlue}
          selected={tags?.indexOf("eventCollection") > -1}
          label={eventsLabel}
          onClick={() => toggleCollection("eventCollection")}
        />
        <CollectionIcon
          readOnly={partnerLogin}
          path={familiesIcon}
          pathOver={familiesIconOn}
          pathOver2={familiesIconOnBlue}
          selected={
            tags?.indexOf("familyCollection") > -1
          }
          label={familiesLabel}
          onClick={() => toggleCollection("familyCollection")}
        />
        <CollectionIcon
          readOnly={partnerLogin}
          path={dogsIcon}
          pathOver={dogsIconOn}
          pathOver2={dogsIconOnBlue}
          selected={tags?.indexOf("petsCollection") > -1}
          label={dogsLabel}
          onClick={() => toggleCollection("petsCollection")}
        />
        <CollectionIcon
          readOnly={partnerLogin}
          path={greenIcon}
          pathOver={greenIconOn}
          pathOver2={greenIconOnBlue}
          selected={
            tags?.indexOf("ecoCollection") > -1
          }
          label={greenLabel}
          onClick={() => toggleCollection("ecoCollection")}
        />

      </div>
    )
  }
  const toggleChannel = (channel) => {
    //console.log(channels,channel)
    const channelExists = xdata.channel?.includes(channel)
    const block = (!xdata.newListings && partner?.accountId !== '64072805d57d670040d5fab6')
    xdata.newListing = false;
    
    if (channelExists) {
      xdata.channel = xdata.channel.filter((f) => f !== channel)
      if (xdata.channel.length === 0) { xdata.status = 'Pending' }
      //console.log('after removal of channel:', channel, xdata.channel)
    } else {

      xdata.channel = [...xdata.channel, channel]
      xdata.status = 'Approved'
      setChange('status')
    }
    updateData(channelExists?(xdata.channel.length === 0)?`property declined from all channels!`:`removed from channel: #${channel}`:`added to the channel: #${channel}`)
  }


  const handleResetButton = () => {
    // console.log("Reset pressed! resseting xdata:", property)
    // console.log("updated xdata:", xdataPayload)
    // console.log("changing region for:", property.address.region)
    // setNewRegion(property.address.region)
    // xdata.region=property.address.region
    //updateData()
  }

  const editProperty = (id) => {
    //console.log("selected listing:" + propertyId, property)
    localStorage.setItem("property", JSON.stringify(property)) // saving to local the selected listing
    history.push(PATH_PROPERTY+'/'+id, { property, xdata })
  }

  const renderChannels = () => {

    return (

      <div className="channels-main-selection-icons"
        style={{
          paddingTop: '15px',
          display: 'grid',
          gridTemplateColumns: '40px 40px 40px',
          justifyItems: 'center',
        }}>
        {<CollectionIcon
          //readOnly={blockxdata.channel}
          readOnly={partnerLogin}
          path={VTChannelIcon}
          pathOver={VTChannelIconOn}
          pathOver2={VTChannelIconOnBlue}
          selected={xdata?.channel?.includes('VT')&&xdata?.status==='Approved'}
          selected2={false}
          label={VTChannelLabel}
          onClick={() => toggleChannel("VT")}
        />}
        {<CollectionIcon
          readOnly={partnerLogin}
          //readOnly={!xdata.newListings}
          path={SHChannelIcon}
          pathOver={SHChannelIconOn}
          pathOver2={SHChannelIconOnBlue}
          selected={xdata?.channel?.includes('SH')&&xdata?.status==='Approved'}
          selected2={false}
          label={SHChannelLabel}
          onClick={() => toggleChannel("SH")}
        />}
      </div>
    )
  }

  //picture:
  let pic = null;
  let picPosition = 0
  let picLength = 0
  if (!isNullOrEmptyArray(xdata.pictures) && picIndex != null) {
    pic = xdata.pictures[picIndex % xdata.pictures?.length].original
    picPosition = picIndex % xdata.pictures?.length;
    picLength = xdata?.pictures?.length

  } else
    if (!isNullOrEmptyArray(property.pictures) && picIndex != null) {
      pic = property.pictures[picIndex % property.pictures?.length].original
      picPosition = picIndex % property.pictures?.length;
      picLength = property?.pictures?.length
    }
  //main xdata return here:
  return <>
    <td className="px-3 p-3 text-primary cst-cursor">
      
      
    {(extranet_vt_logged_in_role==='admin' && (xdata.region === 'unmapped' || xdata.region === '') ) && 
      <input type="checkbox" value={`${id}_unmapped`} name="listing_ids_to_update[]"  />
    }

    {(extranet_vt_logged_in_role==='admin' && xdata.region !== 'unmapped' && xdata.region !== '') && 
      <input type="checkbox" value={id} name="listing_ids_to_update[]"  />
    }


{extranet_vt_logged_in_role==='partner' && partner.accountId==='585a39dbe43900100017e9e8' &&      
      <label>{xdata.pmName}</label>
    }
    

      
      <h4 >
      <div className="property-main-picture-container">
        <div className="nickname">
          {property.nickname} <span className="property-type">({property?.propertyType})</span><br></br>

          <a target="_blank" href={`https://login.villatracker.com/property/${property._id}`}>
  <span className="property-id">{property._id != null ? property._id : "-"}</span>
</a>
          
        </div>
        <div className="img-number">
          {picIndex ? picIndex + 1 : "Main"}/{picLength} Total
          <div className="garbage-can">
            {!partnerLogin && <ImageWithHover
              path={canOff}
              pathOver={canOn}
              className="garabage-icon"
              tooltip={'DELETE THIS PIC'}
              onClick={removePic}
            />}
          </div>
          <div className="garbage-can">
            {!partnerLogin && <ImageWithHover
              path={starOff}
              pathOver={starOn}
              tooltip={'set as Main PIC'}
              className="garabage-icon"
              onClick={mainPic}
            />}
          </div>
        </div>
        <div className="property-main-picture-container">
          <div className="img-slider">
            <ImageWithHover
              path={picLeft}
              pathOver={picLeftOn}
              className="property-page-prev-next-pic"
              style={{ left: "10px" }}
              onClick={setPrevPic}
            />
            <div
              className="property-main-picture"
              onClick={() => editProperty(id)}
              style={{
                backgroundImage: pic ? `url(${pic})` : "transparent",
                backgroundSize: "cover",
              }}
            />
            <ImageWithHover
              path={picRight}
              pathOver={picRightOn}
              className="property-page-prev-next-pic"
              style={{ right: "10px" }}
              onClick={setNextPic}
            />
          </div>
        </div>
      </div>
      <div className="text-title">{property?.title}
        {!partnerLogin && <ImageWithHover
          path={regenerateOff}
          pathOver={regenerateOn}
          className="property-page-prev-next-pic"
          style={{ right: "10px" }}
          tooltip={'AI generate for title:' + property?.title + ' and rewrite the desc.' + desc}
          onClick={setAITitle}
        />}
      </div>

    </h4>
    </td>
    {/* <td className="px-4 p-3 ">
      <h4>{renderChannels()}
        <br></br>
        {xdata.status}{xdata.newListing ? '(New)' : ''}
      </h4>
    </td> */}
    <td className="px-4 p-3">
      <h4>
        {fullCalendar ? fullCalendar.length : 'undefined'}
      </h4>
    </td>
    
    <td className="px-4 p-3 ">
      <h4>
        {xdata.status}

        { (extranet_vt_logged_in_role==='admin' && xdata.status==='Declined' &&  xdata.declineReason !== '') &&
          <p><i>({xdata.declineReason})</i></p>
        }

        {(extranet_vt_logged_in_role==='admin' && xdata?.statusUpdatedBy != null) &&
          <div><label><i>Status Updated By:</i></label><i>{xdata.statusUpdatedBy}</i></div>
        }

      </h4>
    </td>    
    
    <td className="px-4 p-3">
      <h4>
        {renderSpecialCollections()}<br></br><br></br>
        weekdays: {property?.prices?.basePrice} {property?.prices?.currency}<br></br>
        weekend:  {property?.prices?.weekendBasePrice || property?.prices?.basePrice} {property?.prices?.currency}<br></br>
        {property?.prices?.weeklyPriceFactor < 1 && (
          <>
            week discount: {parseInt(100 - property?.prices?.weeklyPriceFactor * 100)}% <br></br>
          </>
        )}
        {property?.prices?.monthlyPriceFactor < 1 && (
          <>
            month discount: {parseInt(100 - property?.prices?.monthlyPriceFactor * 100)}%
          </>
        )}
      </h4>
      <div className="property-box-footer-left">
          <div className="property-box-footer-left-icon">
            <img src={peopleIcon} alt="" />
            {property?.accommodates}
          </div>
          <div className="property-box-footer-left-icon">
            <img src={bedsIcon} alt="" />
            {xdata?.beds} 
          </div>
          <div className="property-box-footer-left-icon">
            <img src={bathIcon} alt="" />
            {property?.bathrooms}
          </div>
          <div className="property-box-footer-left-icon">
            {/* <img src={bedsIcon} alt="" /> */}
            {property.bedrooms} bedrooms 
          </div>

      </div>
    </td>
    <td className="px-4 p-3 ">
      {!partnerLogin && <Button
        style={{ height: '60px', width: '100px', fontSize: '1rem', borderRadius: '6px' }}
        variant="green"
        text="Geo-Reset"
        onClick={handleResetButton()}
      />}
    </td>
    <td className="px-4 p-3 text-decoration">
      <h4>
        {property?.address?.country},{property?.address?.state},{property?.address?.city} {property?.address?.full}
      </h4>
      {/*<RegionsDropDown
        selectedRegion={selectedRegion}
        selectedSubRegion={selectedSubRegion}
        propertyId={id}
        property={property}
        xdata={xdata}
      />*/} 
    </td>
    <td className="px-4 p-3">
      <h4>
        {agent?.firstName + ' ' + agent?.lastName||''}
      </h4>
    </td>
  </>

}
export default Listingrow
